export const NUMBER = [
	{
		level: 0,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: 1,
		icon: 1,
		name: "Level 0",
		desc: "0",
	},
	{
		level: 1,
		repLevel: "full",
		repCode: "number-2",
		backColorCode: "DCEDC8",
		foreColorCode: "",
		value: 2,
		icon: 2,
		name: "Level 1",
		desc: "1",
	},
	{
		level: 2,
		repLevel: "three-quarter",
		repCode: "number-3",
		backColorCode: "FECDD2",
		foreColorCode: "",
		value: 3,
		icon: 3,
		name: "Level 2",
		desc: "2",
	},
	{
		level: 3,
		repLevel: "empty",
		repCode: "number-4",
		backColorCode: "EEEEEE",
		foreColorCode: "",
		value: 4,
		icon: 4,
		name: "Level 3",
		desc: "3",
	},
	{
		level: 4,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
	{
		level: 5,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
	{
		level: 6,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
	{
		level: 7,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
	{
		level: 8,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
	{
		level: 9,
		repLevel: "empty",
		repCode: "number-1",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
];
